import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ProcesosApi from "api/procesosApi";
import ClienteForm from "../ClientesForm";
import DeudasForm from "../DeudasForm";
import BienesForm from "../BienesForm";
import AdicionalesForm from "../AdicionalesForm";
import DocumentosForm from "../DocumentosForm";
import VerificacionForm from "../VerificacionForm";
import FinanzasForm from "../FinanzasForm";

function StepperContent({
  activeStep,
  formData,
  setFormData,
  setError,
  procesoCreado,
  procesoId,
  finanzasRef,
  verificacionRef,
  handleNext,
  setDisableNext,
}) {
  useEffect(() => {
    if (![0, 4].includes(activeStep)) {
      // Solo los pasos 0 y 4 requieren validación previa
      setDisableNext(false);
    }
  }, [activeStep]);

  // Modificar useEffect de verificación
  useEffect(() => {
    const verificarEstadoInicial = async () => {
      // Solo verifica cuando el paso se activa por primera vez.
      if (activeStep === 4 && procesoId) {
        try {
          let tipo_propuesta = "solicitud";
          const propuestasResponse = await ProcesosApi.obtenerPropuestas(procesoId, tipo_propuesta);
          const propuestaActiva = propuestasResponse.data[0];
          setDisableNext(!propuestaActiva); // Deshabilita si no hay propuesta
          //setDisableNext(!tieneProyeccion);
        } catch (error) {
          console.error("Error verificando propuesta:", error);
          setDisableNext(true);
        }
      } else {
        // Para otros pasos, el botón "siguiente" debe estar habilitado por defecto
        // (a menos que otra lógica lo deshabilite).
        setDisableNext(false);
      }
    };
    verificarEstadoInicial();
  }, [activeStep, procesoId, setDisableNext]);

  const handleVerificacionFinish = async () => {
    if (verificacionRef.current) {
      const success = await verificacionRef.current.handleFinish();
      if (success) {
        handleNext();
      }
    }
  };

  return (
    <React.Fragment>
      {activeStep === 0 ? (
        <ClienteForm
          formData={formData}
          setFormData={setFormData}
          setError={setError}
          procesoCreado={procesoCreado}
          procesoId={procesoId}
        />
      ) : activeStep === 1 ? (
        <DeudasForm
          formData={formData}
          setFormData={setFormData}
          setError={setError}
          procesoCreado={procesoCreado}
          procesoId={procesoId}
        />
      ) : activeStep === 2 ? (
        <BienesForm
          formData={formData}
          setFormData={setFormData}
          setError={setError}
          procesoCreado={procesoCreado}
          procesoId={procesoId}
        />
      ) : activeStep === 3 ? (
        <AdicionalesForm
          formData={formData}
          setFormData={setFormData}
          setError={setError}
          procesoCreado={procesoCreado}
          procesoId={procesoId}
        />
      ) : activeStep === 4 ? (
        <FinanzasForm
          ref={finanzasRef}
          formData={formData}
          setFormData={setFormData}
          setError={setError}
          procesoId={procesoId}
          setDisableNext={setDisableNext}
          // Si se completó para potencialmente actualizar el estado del botón "siguiente".
          onComplete={(data) => {
            if (data.success) {
              setDisableNext(false); // Habilita el botón "siguiente" al completar la proyección.
            }
          }}
        />
      ) : activeStep === 5 ? (
        <DocumentosForm procesoId={procesoId} setError={setError} />
      ) : activeStep === 6 ? (
        <VerificacionForm
          ref={verificacionRef}
          procesoId={procesoId}
          setError={setError}
          formData={formData}
          procesoCreado={procesoCreado}
          onFinish={handleVerificacionFinish}
        />
      ) : null}
    </React.Fragment>
  );
}

StepperContent.propTypes = {
  activeStep: PropTypes.number.isRequired,
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  procesoCreado: PropTypes.bool.isRequired,
  procesoId: PropTypes.number,
  finanzasRef: PropTypes.object,
  verificacionRef: PropTypes.object,
  handleNext: PropTypes.func.isRequired,
  setDisableNext: PropTypes.func.isRequired,
};

export default StepperContent;
